<template>
  <div class="sala">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div :class="cita.citas.length > 1 ? 'cita1' : 'cita'"
         v-if="cita !== undefined && (idEspecialidadFiltro==null || mostrarPorEspecialidadFiltro(cita) || forzarMostradoEspecialidad)"
         :style="cita.style"
         v-b-tooltip.hover.left
         :title="cita.titleDebug"
         @click="mostrarDetalle">
      <div class="copete"
           :style="cita.ancho+'background-color: ' + cita.colorEstatusSDI + '; color: ' + cita.colorEstatusSDI">
        <span>.</span>
      </div>

      <div v-if="dia" dir="auto" :class="{'doc':true, 'cita-urgencia':cita.citaUrgencia}" :style="'top:'+(cita.tamanioN/5)+'px; background-color:rgba(0,0,0,0.1) '" >
        <label style="font-size: 8px; ">
          {{cita.notacionCanalOrigen}}
          {{cita.inicialesDoctor}}
        </label>
        <template v-if="cita.lstImagenes !== undefined && cita.lstImagenes !== null" class="imgLogo">
         <span v-for="im in cita.lstImagenes" v-bind:key="im">
          <img alt="sala" :src="'data:image/png;base64, '+im" v-if="im!==undefined && im!==null"/>
         </span>
        </template>
        <span dir="auto" class="aseguradora"
              v-if="cita.mostrarSiglasAseguradora">
        -{{cita.siglasAseguradora}}</span>
      </div>

      <div v-else dir="auto" :class="{'doc':true, 'cita-urgencia':cita.citaUrgencia}" :style="'top:'+(cita.tamanioN/5)+'px;'" >
          {{cita.notacionCanalOrigen}}
          {{cita.inicialesDoctor}}
        <template v-if="cita.lstImagenes !== undefined && cita.lstImagenes !== null" class="imgLogo">
         <span v-for="im in cita.lstImagenes" v-bind:key="im">
          <img alt="sala" :src="'data:image/png;base64, '+im" v-if="im!==undefined && im!==null"/>
         </span>
        </template>
        <span dir="auto" class="aseguradora"
              v-if="cita.mostrarSiglasAseguradora">
        -{{cita.siglasAseguradora}}</span>
      </div>


    </div>

  </div>
</template>

<script>
export default {
  name: "SalaCalendario",
  components: {},
  props: {
    numeroSala: {
      type: Number,
      default: -1
    },
    cita: {
      type: Object
    },
    idEspecialidadFiltro: {
      type: Number
    },
    forzarMostradoEspecialidad: {
      type: Boolean
    },
    dia: Boolean,
  },
  computed: {
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    citaUrgencia: false
  }),
  beforeCreate: function () {
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {

    mostrarPorEspecialidadFiltro(cita) {
      return cita.citas.includes(c => {
        if (this.idEspecialidadFiltro !== undefined && c.idEspecialidadDoctor != undefined && c.idEspecialidadDoctor != null) {
          const esp = c.idEspecialidadDoctor.split(",");
          try {
            if (esp instanceof Array) {
              return esp.includes(String(this.idEspecialidadFiltro));
            } else {
              return false;
            }
          } catch(e) {
            console.error(e);
            return false;
          }
        }
        return false;
      });
    },
    mostrarDetalle() {
      this.$emit("mostrarDetalle", this.cita);
    }
  }
};
</script>

<style scoped>
@import '~vue-context/dist/css/vue-context.css';

.sala {
  /*min-width: 35px;*/
  width: 0px !important;
  height: 20px;
  font-size: small;
  font-weight: bolder;
}

.fa {
  font-size: 13px !important;
  margin-top: 10px !important;
}

.md-icon-button {
  width: 14px !important;
  min-width: 14px !important;;
  height: 14px !important;;
  margin: 0px !important;;
  font-size: 11px !important;;
}

.cita {
  position: absolute;
  margin-top: -4px;
  display: block;
  width: 20px;
  font-size: 0.4em;
  margin-left: 2px;
  z-index: 6;
  border-radius: 7px;
  border: solid 1px black;
  font-weight: bold;
  color: white;
}

.cita1 {
  position: absolute;
  background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0) 50px,
      rgba(0, 0, 0, 0) 1px,
      #E7AD23 1px,
      #FEF89F 60px
  );
  margin-top: -4px;
  margin-left: 0px;
  display: block;
  width: 20px;
  font-size: 0.4em;
  z-index: 8;
  border-radius: 9px;
  border: solid 2px white;
  font-weight: bold;
  color: white;
}

.cita-urgencia{
  color:red !important;
}

.copete {
  position: absolute;
  width: 29px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  left: 0px;
  top: 0px;
}

.body-sala {
  position: absolute;
  width: 18px;
  left: 0px;
  top: 7px;
}

.aseguradora {
  position: absolute;
  left: 1px;
  top: 6px;
  font-size: 2em;
  color: white;
  background-color: black;
  border: 1px solid black;
  border-radius: 3px;
}

.doc {
  position: absolute;
  left: 1px;
  top: 8px;
  font-size: 2em;
  color: white;
  background-color: black;
  border: 1px solid black;
  border-radius: 3px;
}
</style>
